import { X } from "lucide-react";

const ActiveFilters = ({
  search,
  onClearSearch,
  categories,
  durations,
  priceRange,
  onResetPrice,
  onRemoveCategory,
  onRemoveDuration,
  onClearAll,
}) => {
  const hasPriceFilter = priceRange[0] > 3500 || priceRange[1] < 21000;
  const hasAny = (search && search.trim().length > 0) || categories.length > 0 || durations.length > 0 || hasPriceFilter;

  if (!hasAny) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {search && search.trim() && (
        <button
          onClick={onClearSearch}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs bg-primary/10 text-primary border border-primary/20 hover:bg-primary/20 transition-colors"
        >
          "{search}"
          <X className="h-3 w-3" />
        </button>
      )}
      {categories.map((cat) => (
        <button
          key={cat}
          onClick={() => onRemoveCategory(cat)}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs bg-primary/10 text-primary border border-primary/20 hover:bg-primary/20 transition-colors"
        >
          {cat}
          <X className="h-3 w-3" />
        </button>
      ))}
      {durations.map((dur) => (
        <button
          key={dur}
          onClick={() => onRemoveDuration(dur)}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs bg-primary/10 text-primary border border-primary/20 hover:bg-primary/20 transition-colors"
        >
          {dur}
          <X className="h-3 w-3" />
        </button>
      ))}
      {hasPriceFilter && (
        <button
          onClick={onResetPrice}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs bg-primary/10 text-primary border border-primary/20 hover:bg-primary/20 transition-colors"
        >
          ₹{priceRange[0].toLocaleString("en-IN")} – ₹{priceRange[1].toLocaleString("en-IN")}
          <X className="h-3 w-3" />
        </button>
      )}
      <button
        onClick={onClearAll}
        className="text-xs text-muted-foreground hover:text-primary underline ml-1"
      >
        Clear all
      </button>
    </div>
  );
};

export default ActiveFilters;
